export const PRODUCT_STATUS_AV = 'av'
export const PRODUCT_STATUS_NL = 'nl'
export const PRODUCT_STATUS_GRATIS = 'gratis'
export const PRODUCT_STATUS_AVAILABLE = ''

export const FULL_PRODUCT_STATUS_AVAILABLE = 'available'
export const FULL_PRODUCT_STATUS_DELIVERY_3 = 'delivery3'
export const FULL_PRODUCT_STATUS_DELIVERY_5 = 'delivery5'
export const FULL_PRODUCT_STATUS_DELIVERY_7 = 'delivery7'
export const FULL_PRODUCT_STATUS_DELIVERY_10 = 'delivery10'
export const FULL_PRODUCT_STATUS_OUT_OF_TRADE = 'outOfTrade'
export const FULL_PRODUCT_STATUS_CURRENTLY_NOT_AVAILABLE =
  'currentlyNotAvailable'
export const FULL_PRODUCT_STATUS_NOT_AVAILABLE = 'notAvailable'
export const FULL_PRODUCT_STATUS_NOT_IN_CATALOG = 'notInCatalog'
export const FULL_PRODUCT_STATUS_UNAVAILABLE = 'unavailable'
export const FULL_PRODUCT_STATUS_AVAILABLE_REPLACEMENT = 'availableReplacement'
export const FULL_PRODUCT_STATUS_GRATIS = 'gratis'
